<template>
  <component :is="component" class="form-control-plaintext">
    <i class="fa fa-fw fa-lg" :class="{
      'fa-caret-up text-success': value && value > 0,
      'fa-caret-down text-danger': value && value < 0
    }"></i>
    {{ $number2text(value, 2) }}
    <template v-if="!$isNaN(value)">%</template>
  </component>
</template>
<script>
import NumberUtilsMixin from 'vue-core/mixins/NumberUtilsMixin';

export default {
  mixins: [ NumberUtilsMixin ],

  props: {
    component: {
      default: 'small'
    },

    value: {
      type: [Number, String],
      default: undefined,
      validator(value) {
        if (value === undefined || value === null) {
          return true;
        }

        if (typeof value === 'string') {
          if (value === 'NaN' || value === 'Infinity') {
            return true;
          }
        }

        return typeof value === 'number';
      }
    }
  }
};
</script>
